import { client } from "../client/client";

export const fetchSavingsData = async (page, limit, query, status) => {
  try {
    const statusParam = status === "All" ? "" : `&status=${status}`;
    const response = await client.get(
      `/api/v1/product-reporting?page=${page}&limit=${limit}&productId=1c746b09-f385-9d13-71d3-d8e01d782387&q=${query}${statusParam}`,
    );
    return response?.data;
  } catch (error) {
    throw error?.response?.data || error;
  }
};

export const getSavingsSummary = async (id) => {
  const response = await client.get(
    `/api/v1/product-reporting/member/${id}/summary?productId=1c746b09-f385-9d13-71d3-d8e01d782387`,
  );
  return response?.data;
};

export const getPersonalSavingsTranscations = async (page, limit, memberId) => {
  const response = await client.get(
    `/api/v1/product-reporting/transactions?page=${page}&limit=${limit}&memberId=${memberId}&productId=1c746b09-f385-9d13-71d3-d8e01d782387`,
  );
  return response;
};

export const exportAllSavings = async (type, status = "All", q = "") => {
  // If status is "All", treat it as empty
  const statusParam = status === "All" ? "" : `status=${status}&`;

  const response = await client.get(
    `/api/v1/product-reporting/export?productId=1c746b09-f385-9d13-71d3-d8e01d782387&${statusParam}format=${type}${q ? `&q=${q}` : ""}`,
    {
      headers: {
        "Content-Type": type === "pdf" ? "application/pdf" : "text/csv",
      },
      responseType: "arraybuffer",
    },
  );

  return response.data;
};

export const exportMemberSavingsTransactions = async (memberId, type) => {
  const response = await client.get(
    `/api/v1/product-reporting/member/${memberId}/summary?productId=1c746b09-f385-9d13-71d3-d8e01d782387&export=${type}`,
    {
      headers: {
        "Content-Type": type === "pdf" ? "application/pdf" : "text/csv",
      },
      responseType: "arraybuffer",
    },
  );

  return response?.data;
};

export const getProductPenalties = async (page, limit, memberId, productId) => {
  const response = await client.get(
    `/api/v1/product-reporting/penalties?page=${page}&limit=${limit}&memberId=${memberId}&productId=${productId}`,
  );
  return response?.data;
};
